<div class="sku-label">
  <div class="top-side">
    <div class="left-side">
      <div class="classification-letter" [style.background-color]="viewModel.strainTypeColor$ | async">
        {{ viewModel.strainTypeSymbol$ | async }}
      </div>
      <img
        *ngIf="viewModel.labelAssetUrl$ | async as labelAssetUrl"
        class="product-image"
        [src]="labelAssetUrl"
        alt="product image" />
    </div>
    <div class="right-side">
      <div
        *ngIf="viewModel | getExpandedGridSize: (viewModel.spoofedColViewModel$ | async) | async as size"
        class="product-size">
        {{ size }}
      </div>
      <div
        appPrintCardScaleDownText
        [maxHeightInPx]="25"
        [maxWidthInPx]="254"
        [decrementFontSizeByNPixelsPerStep]="0.1"
        [useFloatingPointPixels]="true"
        [transparentWhileScaling]="viewModel.viewingInLiveView$ | async"
        class="product-sku">
        {{ viewModel.sku$ | async }}
      </div>
    </div>
  </div>
  <div class="bottom-side">
    <div
      *ngIf="viewModel.labelData$ | async | sectionRowViewModelBasicMethod: 'getRowTitle' as name"
      appPrintCardScaleDownText
      [maxHeightInPx]="70"
      [maxWidthInPx]="368"
      [transparentWhileScaling]="viewModel.viewingInLiveView$ | async"
      class="product-name">
      {{ name }}
    </div>
    <div
      *ngIf="viewModel.labelData$ | async | sectionRowViewModelBasicMethod: 'getBrand' as brand"
      appPrintCardScaleDownText
      [maxHeightInPx]="35"
      [maxWidthInPx]="368"
      [transparentWhileScaling]="viewModel.viewingInLiveView$ | async"
      class="product-brand">
      {{ brand }}
    </div>
  </div>
</div>
